import Limelight from '@dotdev/limelight/limelight'

const LimelightAccordions = () => {
  window.accordionWrappers = []

  const enableCollapseClickingOutsideTarget = function(
    enableCollapse,
    targetSelector
  ) {
    if (enableCollapse) {
      document.addEventListener(`click`, (e) => {
        if (
          !e.target.matches(targetSelector) &&
          Limelight.elements[targetSelector]
        ) {
          Limelight.elements[targetSelector].hide()
        }
      })
    }
  }

  const updateAccordions = function() {
    const startingIndex = window.accordionWrappers.length
    const accordions = document.querySelectorAll(`[data-trigger="accordion"]`)

    if (accordions) {
      accordions.forEach((element, index) => {
        const i = startingIndex + index
        const targetSelector = element.dataset.target
        const $target = document.querySelector(targetSelector)
        const parent = element.parentElement
        const isClickingOutsideTargetEnabled =
          element.dataset.enableClickingOutsideTarget

        setTimeout(() => {
          if (element.classList.contains(`is-open`)) {
            element.click()
          }
        }, 300)

        if (!element.classList.contains(`limelight-initialised`)) {
          // Target the First Accordion on the PDP Page
          let featureAccordionEl = document.querySelector(
            `[data-target="#feature"]`
          )
          let accordionTarget = element.getAttribute(`data-target`)

          window.accordionWrappers[i] = new Limelight(`${targetSelector}`, {
            visible: false,
            slide: true,
            slideSpeed: 5,
            triggerClass: `active`,
            autoFocusSelector: `.auto-focus`,
            bodyClass: `accordion-open`,
            beforeShowCallback: function(element, elements) {
              let closeAccordion = document.querySelector(
                `.accordion-close[data-close-accordion="${targetSelector}"]`
              )
              document.querySelector(`html`).classList.add(`accordion-open`)
              document
                .querySelector(`body`)
                .classList.add(`${targetSelector.substr(1)}`)
              if (closeAccordion) {
                closeAccordion.classList.add(`active`)
              }

              const targetWrapper = document.querySelector(targetSelector)

              const Search = targetWrapper.querySelector(
                `#Search-downshift-input`
              )
              if (Search) {
                setTimeout(() => {
                  Search.focus()
                }, 400)
              }

              window.accordionWrappers.forEach((accordion, ind) => {
                if (Limelight.elements[accordion.target]) {
                  Limelight.elements[accordion.target].hide()
                }
              })

              if (parent.classList.contains(`main-filter`)) {
                const position = $target.getBoundingClientRect().top - 40
                const innerOption = $target.querySelector(`.options`)
                const mainHeight = window.innerHeight
                const inner = mainHeight - innerOption.offsetHeight
                let Height = mainHeight - position

                setTimeout(() => {
                  const targetHeight = $target.offsetHeight

                  if (targetHeight > inner) {
                    $target.style.height = Height + `px`
                    $target.classList.add(`scroll`)
                  }
                }, 300)
              }
            },
            hideCallback: function(element, elements) {
              let closeAccordion = document.querySelector(
                `.accordion-close[data-close-accordion="${targetSelector}"]`
              )
              if (closeAccordion) {
                closeAccordion.classList.remove(`active`)
              }
              document.querySelector(`html`).classList.remove(`accordion-open`)
            }
          })

          element.classList.add(`limelight-initialised`)

          // Trigger Click if the Accordion target === feature
          if (accordionTarget === `#feature`) {
            setTimeout(() => {
              featureAccordionEl.click()
            }, 200)
          }
        }

        enableCollapseClickingOutsideTarget(
          isClickingOutsideTargetEnabled,
          targetSelector
        )
      })
    }
  }

  document.addEventListener(`accordions:update`, updateAccordions)
  updateAccordions()

  const closeAccordions = document.querySelectorAll(`[data-close-accordion]`)
  if (closeAccordions) {
    closeAccordions.forEach((element, index) => {
      element.addEventListener(`click`, () => {
        const target = element.dataset.closeAccordion
        if (target) {
          document.querySelector(`[data-target="${target}"]`).click()
        }
      })
    })
  }
}

export { LimelightAccordions }
